import { DELETE_DOM_ENVIO, DELETE_DOM_ENVIO_FAIL, DELETE_PEDIDO, DOM_ENVIO_DONE, FETCH_DOM_ENVIO, FETCH_ESTADO, FETCH_PROVINCIA, GET_DOM_ENVIO, GET_ESTADO, GET_PROVINCIA, POST_PEDIDO, SET_DIRECCION } from "../actions/types.js";

const initialState = {
  domicilios_envio: [],
  domicilio: {},
  estado: {},
  provincia: {},
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DOM_ENVIO:
      // No se limpia "domicilio": el componente pide la lista en cada
      // montaje y borrarla aqui hacia perder el domicilio que el usuario
      // ya habia elegido para el pedido. La seleccion se valida abajo,
      // cuando llega la lista nueva.
      return {
        ...state,
        domicilios_envio: [],
        isLoading: true,
      };
    case GET_DOM_ENVIO:
      return {
        ...state,
        domicilios_envio: action.payload,
        // Si el domicilio elegido ya no esta en la lista (se dio de baja,
        // o se cambio de cliente) se limpia la seleccion.
        domicilio: action.payload?.some(dom => dom.id === state.domicilio?.id)
          ? state.domicilio
          : {},
        isLoading: false,
      };
    case POST_PEDIDO:
    case DELETE_PEDIDO:
      // Al empezar un carrito nuevo (o al sustituir el que se ha borrado)
      // la seleccion no se arrastra: el usuario debe elegir domicilio.
      return {
        ...state,
        domicilio: {},
      };
    case DELETE_DOM_ENVIO:
      return {
        ...state,
        isLoading: true,
      }
    case DELETE_DOM_ENVIO_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case DOM_ENVIO_DONE:
      return {
        ...state,
        isLoading: false,
      }
    case FETCH_ESTADO:
      return {
        ...state,
        estado: {},
        isLoading: true,
      };
    case GET_ESTADO:
      return {
        ...state,
        estado: action.payload,
        isLoading: false,
      };
    case FETCH_PROVINCIA:
      return {
        ...state,
        provincia: {},
        isLoading: true,
      };
    case GET_PROVINCIA:
      return {
        ...state,
        provincia: action.payload,
        isLoading: false,
      };
    case SET_DIRECCION:
      return {
        ...state,
        domicilio: action.payload,
      };
    default:
      return state;
  }
}
